<template>
  <div style="display:flex">
      <!-- class="upload-demo drag-upload" :drag="drag"-->
    <el-upload
      ref="upload"
     
      :drag="drag"
      show-file-list
      :file-list="fileList"
      :before-upload="beforeAvatarUpload"
      :action="baseUrlFile + '/api/file/upload'"
      :on-preview="handlePreview"
      :on-success="handleSuccess"
      :on-remove="handleRemove"
      :accept="updateData.fileType"
      :limit="limit"
      :on-change="handleChange"
      :class="{ disabledCard: uploadDisabled}"
      :multiple="true"
    >
      <i class="el-icon-upload" v-if="drag"></i>
      <div class="el-upload__text" v-if="drag">
        将文件拖到此处，或
        <em>点击上传</em>
      </div>
      <!-- -----++++++ -->
      <!-- <i class="el-icon-upload"></i>
      <div v-if="drag" class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div> -->
      <!-- +++++++++++ -->
        <!-- <div style="display:flex">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">{{updateData.updateMsg}}</div>
        </div> -->
        <div class="el-upload__tip" v-if="updateData.updateMsg.length>0 && tipPosition==='down'" slot="tip" style="margin-left:0rem">{{updateData.updateMsg}}</div>
    </el-upload>
    <div class="el-upload__tip" v-if="updateData.updateMsg.length>0 && tipPosition==='left'" slot="tip">{{updateData.updateMsg}}</div>

    <!-- 文件预览弹框 -->
    <el-dialog :visible.sync="dialogVisible" :title="`附件查看`" class="uploadView" append-to-body>
      <div style="text-align: center;height: 5.66rem;">
        <img
          style="max-width: 100%;max-height: 100%;"
          :src="dialogImageUrl"
          alt
          v-if="fileType === 'jpg' || fileType === 'png' || fileType === 'gif' || fileType === 'jpeg'"
        />
        <video
          :src="dialogImageUrl"
          alt
          v-if="fileType === 'mp4' || fileType === 'mov'"
          controls="controls"
          height="100%"
        ></video>
        <audio
          :src="dialogImageUrl"
          v-if="fileType === 'mp3' || fileType === 'wav' || fileType === 'mgg'"
          controls
          width="100%"
        ></audio>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'EXUploadFile',
  props: {
    updateData: {
      type: Object
    },
    drag: {
      type: Boolean
    },
    limit: {
      type: Number,
      default: 5,
    },
    itemValue:{
      type: String,
      default: "",
    },
    tipPosition:{
      type: String,
      default: 'down'
    },
  },
  data() {
    return {
      fileType: '',
      baseUrlFile: $config.baseUrlFile,
      dialogVisible: false,
      dialogImageUrl: '',
      fileList: [],
      lookFile:$config.downloadUrl,
      uploadDisabled: false, 
      notifyPromise: Promise.resolve()
    }
  },
  // watch: {
  //   fileList: {
  //     handler(newVal, oldVal) {
  //       this.setAttachmentList(newVal)
  //     },
  //     deep: true
  //   }
  // },
  mounted() {
  },
  methods: {
    // add by weili附件回显
    initAttachmentList(attachment){
      this.fileList = attachment
      if (this.fileList) {
        const tempArr = JSON.parse(JSON.stringify(this.fileList).replace(/attachName/g, 'name'))
        this.fileList = JSON.parse(JSON.stringify(tempArr).replace(/filePath/g, 'url'))
      }
      // this.$nextTick(() => {
      //     this.getAttachmentList(this.fileList)
      //   })
      this.handleChange("",this.fileList)
    },
     // 文件个数变化控制上传按钮的显示和隐藏
     handleChange(file,fileList) {
      if (fileList.length >= this.limit) {
        this.uploadDisabled = true;
      }else{
        this.uploadDisabled = false;
      }
    },
   
    // 获取文件后缀
    getFileType(file) {
      if (file.name) {
        const first = file.name.lastIndexOf('.')
        const namelength = file.name.length
        const filesuffix = file.name.substring(first + 1, namelength)
        return filesuffix
      } else {
        return ''
      }
    },
    // 获取url
    getFilePath(file) {
      if (file.url) {
        const fileUrl = this.lookFile + file.url
        const arr = fileUrl.split('//')
        const first = arr[1].indexOf('/')
        const namelength = arr[1].length
        const filesuffix = arr[1].substring(first + 1, namelength)
        return filesuffix
      } else {
        return ''
      }
    },
    // 附件列表赋值
    setAttachmentList(fileList) {
    
      var fileItem = document.getElementsByClassName('el-upload-list__item')
      const that = this
      if (fileList) {
        if (fileList instanceof Array) {
          const attachment = fileList.map((item, idx) => {
            if (item.status === 'success') {
              var data = {}
              if (item.response) {
                // Object.keys(item.response.body).length > 0
                data = {
                  attachName: item.name,
                  attachType: item.response.body.fileResponseData.fileType,
                  filePath: item.response.body.fileResponseData.filePath,
                  httpUrl: item.response.body.fileResponseData.httpUrl,
                  attachSize:item.response.body.fileResponseData.fileSize,
                }
              } else {
                data = {
                  attachName: item.name,
                  // fileType: that.getFileType(item),
                  // filePath: that.getFilePath(item),
                  attachType: item.fileType,
                  filePath: item.url,
                  httpUrl: item.httpUrl,
                  attachSize:item.attachSize   // add by weili增加文件大小参数
                }
              }
            
              if (item.response) {
                // this.$message.success(item.response.msg)
                // this.successNotify(item.response.msg);
              }
              return data
            }
          })
          this.$emit('update-attachment', attachment, this.itemValue)
        } else {
          if (fileList.response) {
            // this.$message.error(fileList.response.msg)
            this.warningNotify(fileList.response.msg);
          }
        }
      }
    },
    beforeAvatarUpload(file) {
      var result = true
      const fileName = file.name
      const pos = fileName.lastIndexOf('.')
      const lastName = fileName.substring(pos, fileName.length)
      // 限制上传文件的后缀名
      if (this.updateData.fileType.indexOf(lastName.toLowerCase()) === -1) {
        // this.$message.error(this.updateData.updateTypeMsg)
        this.warningNotify(this.updateData.updateTypeMsg);
        result = false
      }
      // 限制上传文件的大小
      const isLt = this.updateData.updateSize && file.size < this.updateData.updateSize
      if (!isLt) {
        // this.$message.error(this.updateData.updateSizeMsg)
        this.warningNotify(this.updateData.updateSizeMsg);
        result = false
      }
      return result
    },
    handleSuccess(res, file, fileList) {
      if (!res.success) {
        this.setAttachmentList(fileList.pop())
      }
      this.setAttachmentList(fileList)
    },
    handleRemove(file, fileList) {
        var fileItem = document.getElementsByClassName('el-upload-list__item')
      const that = this
      let attachment = []
      if (fileList) {
        if (fileList instanceof Array) {
          attachment = fileList.map((item, idx) => {
            if (item.status === 'success') {
              var data = {}
              if (item.response) {
                // Object.keys(item.response.body).length > 0
                data = {
                  attachName: item.name,
                  attachType: item.response.body.fileResponseData.fileType,
                  filePath: item.response.body.fileResponseData.filePath,
                  httpUrl: item.response.body.fileResponseData.httpUrl,
                  attachSize:item.response.body.fileResponseData.fileSize,
                }
              } else {
                data = {
                  attachName: item.name,
                  // fileType: that.getFileType(item),
                  // filePath: that.getFilePath(item),
                  attachType: item.fileType,
                  filePath: item.url,
                  httpUrl: item.httpUrl,
                  attachSize:item.attachSize   // add by weili增加文件大小参数
                }
              }
             
              if (item.response) {
                // this.$message.success(item.response.msg)
                // this.successNotify(item.response.msg);
              }
              return data
            }
          })
        } else {
          if (fileList.response) {
            // this.$message.error(fileList.response.msg)
            this.warningNotify(fileList.response.msg);
          }
        }
      var deleteFile = {}
      if (file) {
        var item = file
         if (item.status === 'success') {
            if (item.response) {
              deleteFile = {
                attachName: item.name,
                attachType: item.response.body.fileResponseData.fileType,
                filePath: item.response.body.fileResponseData.filePath,
                httpUrl: item.response.body.fileResponseData.httpUrl,
                attachSize:item.response.body.fileResponseData.fileSize,
              }
            } else {
              deleteFile = {
                attachName: item.name,
                attachType: item.fileType,
                filePath: item.url,
                httpUrl: item.httpUrl,
                attachSize:item.attachSize   
              }
            }
          }
      }
      this.$emit('remove-attachment', attachment,deleteFile,this.itemValue)
      }
      this.handleChange("",attachment)
    },
    // 文件预览or下载
    handlePreview(file) {
      if (file) {
        this.fileType = this.getFileType(file)
        if (this.fileType === 'jpg' || this.fileType === 'png' || this.fileType === 'gif' || this.fileType === 'jpeg' || this.fileType === 'mp4' || this.fileType === 'mov' || this.fileType === 'mp3' || this.fileType === 'wav' || this.fileType === 'mgg') {
          // this.dialogImageUrl = file.url ? file.url : file.response.body.fileResponseData.httpUrl
          this.dialogImageUrl = file.url ? this.lookFile + encodeURIComponent(file.url): this.lookFile + encodeURIComponent(file.response.body.fileResponseData.filePath)
          this.dialogVisible = true
        } else if (this.fileType === 'pdf') {
          window.open(file.url ? this.lookFile + encodeURIComponent(file.url) : this.lookFile + encodeURIComponent(file.response.body.fileResponseData.filePath), '_blank')
          // window.open(file.url ? file.url : file.response.body.fileResponseData.httpUrl, '_blank')
        } else {
          window.location.href = file.url ? this.lookFile + encodeURIComponent(file.url) : this.lookFile + encodeURIComponent(file.response.body.fileResponseData.filePath)
          // window.location.href = file.url ? file.url : file.response.body.fileResponseData.httpUrl
        }
      }
    },
     warningNotify(msg) {
        let _this = this;
        this.notifyPromise = this.notifyPromise.then(_this.$nextTick).then(() => {
            _this.$notify({
                type: 'warning',
                title: '警告',
                message: msg,
                duration: 2000
            });
        });
    },
    successNotify(msg) {
        let _this = this;
        this.notifyPromise = this.notifyPromise.then(_this.$nextTick).then(() => {
            _this.$notify({
                type: 'success',
                message: msg,
                duration: 2000
            });
        });
    }
  }
}
</script>

<style lang="scss" scoped>
.disabledCard{
  position: relative;
}
//控制隐藏上传按钮
/deep/.disabledCard .el-upload{
  display: none;
}
#addPeopleRuleForm .el-form-item .upload-demo.drag-upload{
  display: block;
}
.drag-upload {
  width: 3rem;
//   padding: 0.14rem 0;
  /deep/ .el-upload {
    width: 100%;
  }
  /deep/ .el-upload-dragger {
    width: 100%;
    height: 1.48rem;
    .el-icon-upload {
      margin: 0.2rem 0 0.15rem;
    }
    .el-upload__text{
        line-height: 1.5;
    }
  }
  /deep/ .el-upload-list__item-name {
    width: 80%;
  }
  //注释此处：把附件图标覆盖了
  // /deep/ .el-upload-list__item {
  //   .el-icon-document {
  //     display: inline-block;
  //     width: 0.18rem;
  //     height: 0.18rem;
  //     vertical-align: text-bottom;
  //     &::before {
  //       display: none;
  //     }
  //   }
  // }
}
.uploadView {
  /deep/ .el-dialog {
    height: 6.5rem;
    overflow: hidden;
    /deep/ .el-dialog__header {
      height: 0.5rem;
      line-height: 0.4rem;
      text-align: left;
    }
    /deep/ .el-dialog__body {
      height: calc(100% - 0.5rem);
      color: #fff;
      & > div {
        height: 100%;
        img {
          height: 100%;
        }
      }
    }
  }
}
.el-upload__tip{
  margin-left: .2rem;
}
</style>


// WEBPACK FOOTER //
// src/components/EXUpload/uploadFile.vue